import React, { useRef, useState, useEffect } from "react";
import loadImage from "blueimp-load-image";
import { UPLOAD_LIMIT } from "../../Utils/Constants";

const ImageUpload = ({
  onChangeContent,
  isGif,
  contentUrl,
  showErrorMsg,
  preserveOrientation = true,
  defaultLoad = false,
}) => {
  const [content, setContent] = useState(null);
  const [imgViewable, setImageViewable] = useState(null);
  const imageButton = useRef();

  useEffect(() => {
    if (content) onChangeContent(content);
  }, [content]);

  useEffect(() => {
    setImageViewable(contentUrl);
  }, [contentUrl]);

  useEffect(() => {
    if (!defaultLoad) return;
    if (imageButton.current === null) return;
    imageButton.current.click();
  }, [imageButton]);

  const selectFile = (e) => {
    if (e.target.files && e.target.files[0]) {
      const fileContent = e.target.files[0];

      // enforce file size limit
      if (fileContent.size > UPLOAD_LIMIT) {
        showErrorMsg && showErrorMsg();
        return;
      }

      setImageViewable(URL.createObjectURL(fileContent));
      if (isGif || !preserveOrientation) {
        setContent(fileContent);
      } else {
        const type = fileContent.type;
        loadImage.parseMetaData(fileContent, function (data) {
          var orientation = 0;
          if (data.exif) {
            orientation = data.exif.get("Orientation");
          }
          loadImage(
            fileContent,
            function (canvas) {
              var base64data = canvas.toDataURL(type);
              var img_src = base64data.replace(
                /^data\:image\/\w+\;base64\,/,
                ""
              );
              setContent(img_src);
              const img_content = "data:" + type + ";base64," + img_src;
              setImageViewable(img_content);
            },
            {
              canvas: true,
              orientation: orientation,
            }
          );
        });
      }
    }
  };
  return (
    <React.Fragment>
      <div className="col-12" style={defaultLoad ? { display: "none" } : {}}>
        <label htmlFor="image">
          Upload {isGif ? "Gif " : "Image "} &nbsp;{" "}
        </label>
        <input
          ref={imageButton}
          type="file"
          id="image"
          name="image"
          accept={`${isGif ? "image/gif" : "image/jpeg, image/png"}`}
          className="form-control-file"
          style={{ display: "none" }}
          onChange={selectFile}
        />
        <button
          className="btn btn-green"
          onClick={() => imageButton.current.click()}
        >
          Choose {isGif ? "Gif" : "Image"}
        </button>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        {imgViewable && (
          <div className="mt-3">
            <img
              src={imgViewable}
              alt="post_img"
              className="w-100"
              style={{
                maxHeight: "100px",
                objectFit: "contain",
              }}
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/ContentUpload/ImageUpload.js